import React from "react";
import { InputWrapper } from "./styles";

const Input = (props) => {
	const {
		errorMessage,
		name,
		type,
		placeholder,
		className,
		onChange,
		onFocus,
		onBlur,
	} = props;
	return (
		<InputWrapper>
			{errorMessage && (
				<span>
					<i className="error-icon fa fa-exclamation-circle"></i>
					<label className="input-error select-error-pos">{errorMessage}</label>
				</span>
			)}
			<input
				name={name}
				type={type}
				placeholder={placeholder}
				className={className}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
			></input>
		</InputWrapper>
	);
};

export default Input;
